import CalendarDaysSvg from '@assets/images/svg/calendar-days.svg';
import React from 'react';
import { View } from 'react-native';

export interface CalendarDaysIconProps {
    size?: number;
    color?: string;
}

export function CalendarDaysIcon({ size = 24, color = '#4D4D4D' }: Readonly<CalendarDaysIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CalendarDaysSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CalendarDaysIcon;
